import {HttpExclude, Request, RequestExpose} from '@simpli/serialized-request'
import {ExpansibleCollection} from '@simpli/resource-collection'
import {OrbitTransaction} from '@/model/resource/OrbitTransaction'

@HttpExclude()
export class OrbitTransactionCollection extends ExpansibleCollection<
  OrbitTransaction
> {
  resource?: IOrbitTransactionCollectionResourcesHolder

  @RequestExpose() limit: number | null = null
  @RequestExpose() page: number | null = null
  @RequestExpose() round: number | null = null
  @RequestExpose() address: string | null = null
  @RequestExpose() eventname: string | null = null
  @RequestExpose() hash: string | null = null
  @RequestExpose() idOrbitProjectFk: number | null = null
  @RequestExpose() idTokenPricedFk: number | null = null
  /** blockchain_version.networkIdentifier: 'neo3/mainnet' | 'neo3/testnet' */
  @RequestExpose() networkIdentifier: string | null = null

  constructor() {
    super(OrbitTransaction)
  }

  queryAsPage() {
    return this.listOrbitTransaction()
  }

  async listOrbitTransaction() {
    return await Request.get(`/client/orbit-transaction`, {
      params: this.params,
    })
      .name('listOrbitTransaction')
      .as(this)
      .getResponse()
  }

  async sumUserTransactionCount(
    address: string,
    eventname?: string
  ): Promise<number> {
    const params: Record<string, string> = {address}
    if (eventname) {
      params.eventname = eventname
    }
    return await Request.get(`/client/orbit-transaction/sum`, {
      params,
    })
      .name('sumUserTransactionCount')
      .asNumber()
      .getData()
  }

  /**
   * Fetches the count of orbit transactions for a given address, round and project.
   * Uses list with limit=1 and returns the total from the response.
   */
  async getTransactionCountForReward(
    address: string,
    round: number,
    idOrbitProjectFk: number
  ): Promise<number> {
    const coll = new OrbitTransactionCollection()
    coll.address = address
    coll.round = round
    coll.idOrbitProjectFk = idOrbitProjectFk
    coll.limit = 1
    coll.page = 0
    await coll.listOrbitTransaction()
    return (coll as any).total ?? 0
  }

  /**
   * Fetches the count of orbit transactions for a given address, round and token.
   * Counts ALL transactions in that round for projects using that token (grouped by token).
   */
  async getTransactionCountForRewardByToken(
    address: string,
    round: number,
    idTokenPricedFk: number
  ): Promise<number> {
    const coll = new OrbitTransactionCollection()
    coll.address = address
    coll.round = round
    coll.idTokenPricedFk = idTokenPricedFk
    coll.limit = 1
    coll.page = 0
    await coll.listOrbitTransaction()
    return (coll as any).total ?? 0
  }
}

export interface IOrbitTransactionCollectionResourcesHolder {}
